import { environment } from 'src/environments/environment';

export const URLS = {
  GOBAL_URL: environment.url_point,

  Translate:{
    AwsTranslation:'/api/Squar/Translate',
    DetectPersonName:'/api/Squar/detect-names'
  },

  PacketsForms:{
    AvaliableForms:'/api/PortalPackets/GetPacketDetails?ClientID=',
    UpdateStatus:'/api/PortalPackets/UpdatePacketStatus?Status=',
    GetPacketforms:'/api/PortalPackets/GetPacketFormData'
  },

  DashBoard:{
    getAppointments:'/api/Dashboard/GetAppointments?ClientID=',
    gettodos:'/api/Dashboard/GetToDo?ClientID=',
    getDashboardCounts:'/api/Dashboard/GetDashboardCounts?ClientID=', 
    getPdf : '/api/Dashboard/GetPDFDocument?ClientID=' 
  
  },

  Health_Record: {
    getproblemList: '/api/HealthRecord/GetProblemList?ClientID=',
    getmedicationList: '/api/HealthRecord/GetMedicationList?ClientID=',
    GetScheduleMedicationList: '/api/HealthRecord/GetScheduleMedicationList?ClientID=',
    getallergylist:'/api/HealthRecord/GetAllergyList?ClientID=',
    getnonallergylist:'/api/HealthRecord/GetNonAllergyList?ClientID=',
    getdocumentlist:'/api/HealthRecord/GetDocumentList?ClientID=',
    getlabresults:'/api/HealthRecord/GetLabResult?ClientID=',
    getvitalsign:'/api/HealthRecord/GetVitalSign?ClientID=',
    getdietorder:'/api/HealthRecord/GetDietOrder?ClientID=',
    getimmunization:'/api/HealthRecord/GetImmunization?ClientID=',
    getdiagnosis:'/api/HealthRecord/GetDiagnosis?ClientID=',
    getencounters:'/api/HealthRecord/GetEncounter?ClientID=',
    getappointments:'/api/HealthRecord/GetAppointments?ClientID=',
    getsmokingstatus:'/api/HealthRecord/GetSmokingStatus?ClientID=',
    getcontacts:'/api/HealthRecord/GetContact?ClientID=',
    getHouseholdMembers:'/api/HealthRecord/GetHouseholdMembers?ClientID=',
    gettreatment:'/api/HealthRecord/GetTreatmentPlan?ClientID=',
    getnursing :'/api/HealthRecord/GetPlanOfNursing?ClientID=',
    getlifePlan:'/api/HealthRecord/GetLifePlan?ClientID=',
    print:'/api/HealthRecord/HealthRecordPrint?ClientID=',
    getgad7:'/api/HealthRecord/GetGAD7?ClientID=',
    getcrosschild:'/api/HealthRecord/GetCrossCuttingChild?ClientID=',
    getcrossparent:'/api/HealthRecord/GetCrossCuttingParent?ClientID=',
    getcrossadult:'/api/HealthRecord/GetCrossCuttingAdult?ClientID=',
    getPhq : '/api/HealthRecord/GetPHQ9?ClientID=',
    getSolaceVital : '/api/SBHHealthRecord/GetSolaceVitalSigns?ClientID=',
    getAudit : '/api/SBHHealthRecord/GetAudit?ClientID=',
    getAims : '/api/SBHHealthRecord/GetAIMS?ClientID=',
    getAimsTd : '/api/AimsTd/GetAims?clientId=',
    getMadrs : '/api/SBHHealthRecord/GetMADRS?ClientID=',
    getPtsd : '/api/SBHHealthRecord/GetPTSD?ClientID=',
    gethamilton: '/api/SBHHealthRecord/GetHamilton?ClientID=',
    getprepprov : '/api/SBHHealthRecord/GetPrepProvider?ClientID=',
    getpreptherapy : '/api/SBHHealthRecord/GetPrepTherapy?ClientID=',
    getDisorder: '/api/SBHHealthRecord/GetMoodDisorderScale?ClientID=',
    getSleep : '/api/SBHHealthRecord/GetEpworthSleepinessscale?ClientID=',
    getBinge: '/api/SBHHealthRecord/GetBingeEatingScale?ClientID=',
    getBocs :'/api/SBHHealthRecord/GetYBOCS?ClientID=',
    getHIVTemplateDetails: '/api/HivRiskAssessment/GetHivRiskAssessmentTemplateDetail?ClientID=',
    getHIVDetails:'/api/HivRiskAssessment/GetHivRiskAssessment?ClientID=',
    insertHIVRiskAssessment: '/api/HivRiskAssessment/InsertHivRiskAssessment',
    updateHIVRiskAssessment:'/api/HivRiskAssessment/UpdateHivRiskAssessment',
    getgeneral:'/api/TreatmentPlanBase/Get_TreatementPlanBaseGeneralInfo?ClientID=',
    getsignature:'/api/TreatmentPlanBase/Get_TreatementPlanSignature?UD_IAP_MSDPID=',
    gettreatmentplan :'/api/TreatmentPlanBase/Get_TreatementPlanBaseReviewInfo?UD_IAP_MSDPID=',
    getservice:'/api/TreatmentPlanBase/Get_TreatmentPlanService?UD_IAP_MSDPID=',

    getneeds:'/api/TreatmentPlanBase/Get_AssessedNeeds?UD_IAP_MSDPID=',
    getgoals:'/api/TreatmentPlanBase/Get_AssessedNeedsGoals?UD_IAP_MSDP_AssessedNeedsID=',
    getObjective:'/api/TreatmentPlanBase/Get_AssessedNeedsGoalsObjectives?UD_IAP_MSDP_AssessedNeeds_GoalsID=',
    getInterventions:'/api/TreatmentPlanBase/Get_AssessedNeedsObjectivesInterventions?UD_IAP_MSDP_AssNeeds_Goals_ObjectivesID=',
    getSafteyplan:'/api/HealthRecord/GetSafetyPlan?ClientID=',
    getCHLeaseViolation:'/api/HealthRecord/GetCHLeaseViolation?ClientID=',
    getVocaQuestionnaireForm:'/api/MMTHealthRecord/GetVocaQuestionnaireForm?ClientID=',
    getcrafft:'/api/MMTHealthRecord/GetCrafftForm?ClientID=',
    getDevLocusForms:'/api/MMTHealthRecord/GetDevLocusForms?ClientID=',
        getCalocus:'/api/MMTHealthRecord/GetCalocus?ClientID=',
        savesign:'/api/TreatmentPlanBase/UpdateTreatmentPlanSignature'

  },
  gad7api : {
    insertgap7:'/api/GAD7/InsertGAD7',
    template_details:'/api/PHQ9/GetPHQGADOptions?ClientID='
  },

  tbrisk:{
    gettemplate:'/api/AdultTBRiskAssessment/GetAdultTBRiskAssessmentTemplateDetail?ClientID=',
    gettbrisk:'/api/AdultTBRiskAssessment/GetAdultTBRiskAssessment?ClientID=',
    addnewrisk:'/api/AdultTBRiskAssessment/InsertAdultTBRiskAssessment',
    updateTBRisk:'/api/AdultTBRiskAssessment/UpdateAdultTBRiskAssessment'
 },
 AssistiveTechnology:{
updatepackect:'/api/FCBDD_AssistiveTechnologyAndRemoteSupportsWorksheet/UpdateFCBDDAssistiveTechnologyAndRemoteSupportsWorksheet',
gettemplate:'/api/FCBDD_AssistiveTechnologyAndRemoteSupportsWorksheet/GetFCBDDAssistiveTechnologyAndRemoteSupportsWorksheetTemplateDetail?CompanyCode=',
getassistivetechnology:'/api/FCBDD_AssistiveTechnologyAndRemoteSupportsWorksheet/GetFCBDDAssistiveTechnologyAndRemoteSupportsWorksheet?ClientID='
},
ispdocument:{
getISP:'/api/OHISPDocument/GetOHISPDocumentFormData?ClientID=',
updatesign:'/api/OHISPDocument/UpdateMemberISPSign',
ISPprint:'/api/OHISPDocument/GenerateOHISPDocumentPDF?ClientID=',
signbuttonshowandhide:'/api/OHISPDocument/ValidateSignatureAccess',
ISPdocument:'/api/HealthRecord/GetDocumentList?ClientID=',
},
 SDOHScreeningTool: {
  getSDOHScreeningToolOptions: '/api/SDOHScreeningTool/GetSDOHScreeningToolOptions',
  getSDOHScreeningToolDetails: '/api/SDOHScreeningTool/GetSDOHScreeningToolDetails?SDOHScreeningToolID=',
  insertSDOHScreeningTool: '/api/SDOHScreeningTool/InsertSDOHScreeningTool',
  updateSDOHScreeningTool: '/api/SDOHScreeningTool/UpdateSDOHScreeningTool',
  deleteSDOHScreeningTool: '/api/SDOHScreeningTool/DeleteSDOHScreeningTool?SDOHScreeningToolID=',
},
  // '/api/Profile/ValidateCompanyCode?Email= &CompanyCode= &Action='
  Profile: {
    login:'/api/Profile/Login?UserName=',
    MFA:'/api/Profile/VerifyOTP',
    profile:'/api/Profile/ClientProfileView',
    createProfile: '/api/Profile/CreateProfile',
    changepassword: '/api/Profile/changePassoword',
    checkcompanycode:'/api/Profile/ValidateCompanyCode',
    checkemail:'/api/Profile/ValidateEmail?EmailAddress=',
    insertClientProfile:'/api/Profile/InsertClientProfile',
    profileImage:'/api/Profile/GetClientProfileImage',
    getSecurityQA:'/api/Profile/GetSecurityQA',
    forgotpassword: '/api/Profile/UpdatePassword',
    createPreAdmission:'/api/Profile/CreatePreadmission',
    addClient:'/api/Profile/AddClient',
    getSecurityQuestion:'/api/Profile/GetSecurityQuestion',
    companylogo:'/api/Profile/GetCompanyLogo',
    broadcastMessage:'/api/Profile/GetBroadCastData?CompanyID=',
    switchclient:'/api/Profile/GetSwitchClientData',
    portalLogout:'/api/Profile/Logout?ClientID=',
    signUpData:'/api/Profile/GetClientSignUpData',
    getUserClient : '/api/Profile/GetUserClient',
    updatePolicy : '/api/Profile/UpdatePolicy',
    auditlog : '/api/Profile/Auditlog',
    createFCBDDApplication: '/api/Profile/CountyBoardApplication',
    createFcbddCountyBoardApplication: '/api/FcbddCountyBoard/SubmitApplication',

   
  },

  SSO:{
    GetUrl : '/api/SSO/GetUrl',
    GetUser : '/api/SSO/GetAuthUser',
    GetAuthOtp : '/api/SSO/SsoAuthGenerateOTP',
    VerifyToken : '/api/SSO/SsoVerifyToken'
  },

  Task: {
    taskdetails:'/api/Task/GetTaskDetails?ClientID=',
    taskUpdatedetails: '/api/Task/UpdateTaskDetails'
  },
  SecureMessage: {
    securemessage: '/api/SecureMessage/GetSecureMessages?ClientId=', 
    insertsecuremessage:'/api/SecureMessage/InsertInboxSecureMessage',   
    updatesentmessage:'/api/SecureMessage/UpdateSentSecureMessage',
    updateSecureMessagesread: '/api/SecureMessage/UpdateSecureMessagesread?Messageid=',
    deletesecuremessage:'/api/SecureMessage/DeleteSecureMessage?MessageId=',
    replysecuremessage:'/api/SecureMessage/GetReplySecureMessages?ClientID=',
    secureMessageDocument:'/api/SecureMessage/GetSecureMessageDocument?DocumentID=',
    auditsecuremessageinsert:'/api/SecureMessage/InsertAuditSecureMessage',
    auditsecuremessagedelete:'/api/SecureMessage/DeleteAuditSecureMessage'
  },
  UploadDoc: {
    getupdoc:'/api/PortalDocumentUpload/GetPortalDocumentUpload?ClientID=',
    doctype: '/api/PortalDocumentUpload/GetPortalDocumentTemplateDetail?clientID=',
    insertdoc:'/api/PortalDocumentUpload/InsertPortalDocumentUpload',
    updatedoc:'/api/PortalDocumentUpload/UpdatePortalDocumentUpload',
    deletedoc:'/api/PortalDocumentUpload/DeletePortalDocumentUpload',
    auditdocinsert:'/api/PortalDocumentUpload/InsertAuditPortalDocumentUpload',
    auditdocdelete:'/api/PortalDocumentUpload/DeleteAuditPortalDocumentUpload'
  },

  MyTeam : {
    myteam : '/api/Myteam/GetAssignedStaffList?ClientId=',
  },
  MailMerge: {
    savemail:'/api/MailMerge/InsertMailMergeDetails',
    editmail:'/api/MailMerge/UpdateMailMergeDetails',
    getmail: '/api/MailMerge/GetMailMergeTemplateDetail?CompanyID=',
    gettemplate: '/api/MailMerge/GetMailMergeTemplateDetail?CompanyID=',
    maildetails:'/api/MailMerge/GetMailMergeDetails?ClientID=',
    maildetailID:'/api/MailMerge/GetMailMergeDetails?ClientID=',
    deletemail:'/api/MailMerge/DeleteMailMergeDetails?LetterTemplateID='
  },
  Surveys:{
    getClinicalSurveys:'/api/ClinicSatisfactionSurvey/GetClinicSatisfactionSurvey?ClientID=',
    getSurveyTemplateDetails:'/api/ClinicSatisfactionSurvey/GetClinicSatisfactionSurveyTemplateDetail?clientID=',
     deleteClinicalSurvey:'/api/ClinicSatisfactionSurvey/DeleteClinicSatisfactionSurvey?ClinicSatisfactionSurveyID=',
     saveNewSurvey:'/api/ClinicSatisfactionSurvey/InsertClinicSatisfactionSurvey',
     editSurveys:'/api/ClinicSatisfactionSurvey/UpdateClinicSatisfactionSurvey',
  },
  RequestAppointment:{
    requestAppointment:'/api/RequestAppointment/GetAppointmentStaffDetails?ClientID=',
    getTimeZone:'/api/RequestAppointment/GetTimeZoneDetails',
    saveAppointment:'/api/RequestAppointment/InsertRequestAppointment',
    unavailtime:'/api/RequestAppointment/GetStaffavailDetails',
    auditrequestAppointment:'/api/RequestAppointment/InsertAuditRequestAppointment'
  },
  OnlinePayment:{
    createpayment:'/api/Squar/CreatePaymentRequest',
    dueAmount:'/api/Squar/GetDueAmount?ClientID=',
    clientStatement: '/api/Squar/GetClientStatement',
    wayster_insert :'/api/Squar/TestCreatePaymentRequest'
  },

   ESA:{
gettemplate:'/api/EAS_ServiceApplicationUtility/GetEAS_ServiceApplicationUtilityTemplate?CompanyCode=',
getupdate:'/api/EAS_ServiceApplicationUtility/GetEAS_ServiceApplicationUtility?CompanyCode=',
insertESA:'/api/EAS_ServiceApplicationUtility/InsertEAS_ServiceApplicationUtility',
updateESA:'/api/EAS_ServiceApplicationUtility/UpdateEAS_ServiceApplicationUtility',
Get_EASDiagnosis:'/api/EAS_ServiceApplicationUtility/Get_EASDiagnosis?CompanyCode=',
Get_documentList:'/api/EAS_ServiceApplicationUtility/GetEAS_DocumentConfigurationForm?CompanyCode=',
Get_upload_preview:'/api/EAS_ServiceApplicationUtility/GetEAS_ServiceApplicationUtilityDocuments?CompanyCode=',
PrimaryServiceLocation:'/api/EAS_ServiceApplicationUtility/GetEAS_PrimaryServiceLocationByCountyState?CompanyCode=',
GetHandbookPDFByPrimaryServiceLocation:'/api/EAS_ServiceApplicationUtility/GetHandbookPDFByPrimaryServiceLocation?CompanyCode='
 },
 
DEMOGRAPHICS:{
    getTemplateDetails: '/api/MMT_DemographicsForm/GetMMT_DemographicsFormGetTemplateEntity?CompanyCode=',
    insertDemographics: '/api/MMT_DemographicsForm/InsertMMT_DemographicsForm'
  },

  PRE_ADMISSION_STAGING:{
    insertPreAdmissionStaging: '/api/PreAdmissionStaging/InsertPreAdmissionScreeningStaging',
    getPreAdmissionTemplate: '/api/PreAdmissionStaging/GetPreAdmissionTemplate?CompanyCode='
  },

  ZIP_CODE:{
    zipcode:'/api/Zipcode/Get_Zipcodes?CompanyCode=',
    uspsValidation:'/api/Zipcode/Validate_USPSAddress'
  },
  
  ccoLifePlan : {
    ccoLifePlan : '/api/CcoLifePlan/GetCCOLifePlan?ClientID=',
    getccoLifePlanPdf: '/api/CcoLifePlan/GetCCOPDFDocument',
    getccoUserType: '/api/CcoLifePlan/Getapproval?ClientID=',
    ccoLifePlanApproval : '/api/CcoLifePlan/InsertMemberRepresentativeApproval',
    getContactDetail : '/api/CcoLifePlan/GetContactsdetail?ClientID=',
    // GetCCOPortalDocumentUpload : '/api/CcoLifePlan/GetCCOPortalDocumentUpload?ClientID=',
    GetCCOPortalDocumentUpload : '/api/CcoLifePlan/GetCCOPortalDocumentUpload',
    insertCCODocumentUpload : '/api/CcoLifePlan/InsertCCOPortalDocumentUpload',
    deleteCCODoc : '/api/CcoLifePlan/DeleteCCOPortalDocumentUpload',
    ccoAllergies :'/api/CcoLifePlan/GetCCOAllergies?ClientID=',
    auditccoLifePlanApproval:'/api/CcoLifePlan/InsertAuditMemberRepresentativeApproval'
  },

  PHQ9 : {
    getPhqOptions : '/api/PHQ9/GetPHQGADOptions?ClientID=',
    insertPhq : '/api/PHQ9/InsertPHQ',
    updatePhq : '/api/PHQ9/UpdatePHQ',
  },
  PHQ9_MentalAssessment:{
    GetMentalAssessmentofPHQ9: '/api/MentalHealthAssessment/GetMentalHealthAssessment?ClientID=',
    GetMentalAssessmentOptions: '/api/MentalHealthAssessment/GetMentalHealthAssessmentOptions?CompanyCode=',
    insertMentalAssessmentofPHQ9: '/api/MentalHealthAssessment/InsertMentalHealthAssessment'
  },
  LevelOfCare: {
    getRedeterminationCombination : '/api/RedeterminationCombination/GetRedeterminationCombination?ClientID=',
    getRedeterminationCombinationOptions: '/api/RedeterminationCombination/GetRedeterminationCombinationOptions?CompanyCode=',
    updateRedeterminationCombination : '/api/RedeterminationCombination/UpdateRedeterminationCombination'
  },

  SBHVitalapi : {
    insertVital : '/api/SBHHealthRecord/InsertSolaceVitalSings'
  },
  
  Audit : {
    getAuditOptions : '/api/SBHHealthRecord/GetUDO?Type=',
    insertAudit:'/api/SBHHealthRecord/InsertAudit'
  },
    Aims: {
    InsertAimsAPI : '/api/SBHHealthRecord/InsertAIMS'
    },
    Madrs : {
    InsertMadrsAPI : '/api/SBHHealthRecord/InsertMADRS'
    },
    ptsd : {
      InsertPtsdAPI : '/api/SBHHealthRecord/InsertPTSD'
    },
    hemilton : {
      InsertHamilton :'/api/SBHHealthRecord/InsertHamilton',
    },
    prepProvider : {
      InsertProvider :'/api/SBHHealthRecord/InsertPrepProvider',
    },
    prepTherapy : {
      InsertTherapy: '/api/SBHHealthRecord/InsertPrepTherapy'
    },
    DisorderScale : {
      InsertDisorder : '/api/SBHHealthRecord/InsertMoodDisorderScale'
    },
    SleepScale : {
      InsertSleep : '/api/SBHHealthRecord/InsertEpworthSleepinessscale'
    },
    BingeScale :{
      InsertBinge :'/api/SBHHealthRecord/InsertBingeEatingScale'
    },
    ybocsScale : {
      InsertBocs :'/api/SBHHealthRecord/InsertYBOCS'
    },
     LevelofCare: {
       GetLevelofCare : '/api/LevelofcareFreedom/GetLevelOfCareFreedom?ClientID=',
       UpdateLevel:'/api/LevelofcareFreedom/UpdateFreedomOfChoice',
       GetTemplate:'/api/LevelofcareFreedom/GetFreedomOfChoiceSoloTemplateDetail?CompanyCode='

     },
     ConsentOfVideoandAudio:{
      GetVideoAudiorecords:'/api/ConsentVideoAudio/GetVideoandAudioConsent?ClientID=',
      GetTemplateOptions:'/api/ConsentVideoAudio/GetVideoandAudioConsentOptions?CompanyCode=',
      UpdateVideandAudiorecords:'/api/ConsentVideoAudio/UpdateVideoandAudioConsent'
     },
     FCBDD_MedicaidDueProcess:
    {
      GetMedicaidDueprocess :'/api/FCBDD_MedicaidDueProcess/GetFCBDD_MedicaidDueProcessFormData?ClientID=',
      GetTemplate :'/api/FCBDD_MedicaidDueProcess/GetFCBDD_MedicaidDueProcessTemplateDetail?CompanyCode=',
      UpdateMedicaidDueprocess:'/api/FCBDD_MedicaidDueProcess/UpdateFCBDD_MedicaidDueProcessForm'
    },
PEARLS:{
  GetPearlsDetails: '/api/PEARLS/GetPEARLSDetails?ClientID=',
  GetPEARLSTemplateRequest: '/api/PEARLS/GetPEARLSTemplateRequest?ClientID=',
  InsertPEARLS: '/api/PEARLS/InsertPEARLS',
  UpdatePEARLS: '/api/PEARLS/UpdatePEARLS',
  DeletePEARLS: '/api/PEARLS/DeletePEARLS?PEARLSID=',
},
EducationReportCard: {
  GetEducationReportCardDetails: '/api/EducationReportCard/GetEducationReportCardDetails?ClientID=',
  InsertEducationReportCard: '/api/EducationReportCard/InsertEducationReportCard',
  DeleteEducationReportCard: '/api/EducationReportCard/DeleteEducationReportCard?EducationReportCardID=',
},

StandardMarketingROI: {
  getTemplate: '/api/StandardMarketingReleaseOfInformation/GetStandardMarketingReleaseOfInformationTemplate',
  getDetails: '/api/StandardMarketingReleaseOfInformation/GetStandardMarketingReleaseOfInformationDetails',
  insert: '/api/StandardMarketingReleaseOfInformation/InsertStandardMarketingReleaseOfInformation',
  update: '/api/StandardMarketingReleaseOfInformation/UpdateStandardMarketingReleaseOfInformation',
  delete: '/api/StandardMarketingReleaseOfInformation/DeleteStandardMarketingReleaseOfInformation',
},
CrisisResponsePlan: {
  GetCrisisResponsePlan: '/api/MFH_Crisis/GetCrisisResponsePlan?ClientID=',
  InsertCrisisResponsePlan: '/api/MFH_Crisis/InsertCrisisResponsePlan',
  UpdateCrisisResponsePlan: '/api/MFH_Crisis/UpdateCrisisResponsePlan',
  DeleteCrisisResponsePlan: '/api/MFH_Crisis/DeleteCrisisResponsePlan?CRPLA_CrisisResponsePlanID=',
},
AdverseChildhoodExperiences: {
  GetAdverseChildhoodExperiencesDetails: '/api/AdverseChildhoodExperiences/GetAdverseChildhoodExperiencesDetails?ClientID=',
  InsertAdverseChildhoodExperiences: '/api/AdverseChildhoodExperiences/InsertAdverseChildhoodExperiences',
  UpdateAdverseChildhoodExperiences: '/api/AdverseChildhoodExperiences/UpdateAdverseChildhoodExperiences',
  DeleteAdverseChildhoodExperiences: '/api/AdverseChildhoodExperiences/DeleteAdverseChildhoodExperiences?UD_AdverseChildhoodExperiencesID=',

},
MFH_Vitals: {
  GetMFHVitals: '/api/MFH_Vitals/GetMFHVitals?ClientID=',
},
  NICHQVanderbilt: {
  getDetails: '/api/NICHQVanderbiltAssessmentScales/GetNICHQVanderbiltAssessmentScalesDetails',
  insert: '/api/NICHQVanderbiltAssessmentScales/InsertNICHQVanderbiltAssessmentScales',
  update: '/api/NICHQVanderbiltAssessmentScales/UpdateNICHQVanderbiltAssessmentScales',
  delete: '/api/NICHQVanderbiltAssessmentScales/DeleteNICHQVanderbiltAssessmentScales',
  getOptions: '/api/NICHQVanderbiltAssessmentScales/GetNICHQVanderbiltOptions',
}


}

export const Constant ={
  Timing:{
    timeoutWarningInSeconds : 120
  },
  getId:{
    phqId : 0,
    gadId : 0,
    surveyId : 0,
    SBHVitalID : 0,
    auditID: 0,
    aimsID: 0,
    madrsID: 0 ,
    ptsdID: 0,
    hamID : 0,
    provID: 0 ,
    TherapyID: 0,
    SLeepID:0,
    BingeID : 0,
    BcosID :0
  }
 }